export const infrastructureEquipmentTitles = {
  backbone: 'Backbone',
  leadIn: 'Lead In',
  customerAccessCabling: 'Customer access cabling',
  gPOinMDF: 'GPO in MDF',
  uPSinMDF: 'UPS in MDF',
  gPOinRisers: 'GPO in risers',
  uPSinRisers: 'UPS in risers'
}
